import { ComingSoon } from './pages/ComingSoon/ComingSoon';

import './App.scss';

export const App = () => {
  return (
    <div className="app">
      <ComingSoon />
    </div>
  );
};
